export default __webpack_public_path__ + "static/media/VisitTrailer.744e369b.svg";